function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "3D10EC16-093A-4667-9FC6-A2784D891ACF");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with sketchtool.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Permatrol",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "Pagina_principal",
  transform: "translate(-673.000000, -2010.000000)",
  fill: "#EE3746",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "TERCERO",
  transform: "translate(0.000000, 1967.000000)"
}, React.createElement("g", {
  id: "Group-8",
  transform: "translate(655.000000, 25.000000)"
}, React.createElement("g", {
  id: "clock",
  transform: "translate(18.000000, 18.000000)"
}, React.createElement("path", {
  d: "M33.6029739,10.6876389 C31.7576961,6.38555556 28.6219935,3.25677288 24.2839951,1.40663399 C22.1158252,0.481936275 19.8443137,0.00960784314 17.4712337,0.00960784314 C15.0985539,0.00960784314 12.843799,0.47747549 10.678031,1.40663399 C6.37594771,3.25185458 3.22634804,6.37863562 1.37781046,10.6876389 C0.451511438,12.8464297 0,15.1081046 0,17.4807843 C0,19.8539216 0.451511438,22.1343546 1.37781046,24.2936029 C3.22634804,28.6026062 6.37634804,31.7481454 10.678031,33.5938235 C12.8441993,34.522982 15.0984967,34.9903922 17.4712337,34.9903922 C19.8439706,34.9903922 22.1158252,34.5180637 24.283652,33.5938235 C28.6216503,31.7436275 31.7573529,28.5952859 33.603031,24.2936029 C34.5321324,22.1274346 35,19.8539216 35,17.4807843 C35,15.1081046 34.5325327,12.85375 33.6029739,10.6876389 Z M30.8093791,25.2121814 C29.4356291,27.5681046 27.5536356,29.437116 25.1833578,30.8189869 C22.8274346,32.1927369 20.2460703,32.885531 17.471634,32.885531 C15.3859314,32.885531 13.3957353,32.4838317 11.5010458,31.660817 C9.6064134,30.8382026 7.97056373,29.7567484 6.60213235,28.3887173 C5.23370098,27.0202859 4.14452614,25.3684804 3.33008987,23.4705882 C2.51805556,21.579616 2.12453431,19.5669444 2.12453431,17.4808415 C2.12453431,14.7060049 2.80629085,12.1377369 4.17232026,9.78833333 C5.54321078,7.43035131 7.42560458,5.55933824 9.77912582,4.18147059 C12.1322467,2.80366013 14.6968546,2.11452614 17.4712337,2.11452614 C20.2460703,2.11452614 22.8269771,2.80772059 25.1829575,4.18147059 C27.5532353,5.56339869 29.4311683,7.43435458 30.8089788,9.78827614 C32.1867892,12.1417974 32.8755229,14.7060049 32.8755229,17.4807843 C32.8755229,20.2556781 32.1913072,22.8414461 30.8093791,25.2121814 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M18.5812255,17.3277451 L18.5812255,7.41513889 C18.5812255,6.82196895 18.0644036,6.34352124 17.4711765,6.34352124 C16.9163807,6.34352124 16.4187173,6.82196895 16.4187173,7.41513889 L16.4187173,17.4807843 C16.4187173,17.5 16.4570915,17.5767484 16.4570915,17.6339379 C16.4187173,17.9784477 16.5146814,18.265482 16.7441258,18.4953268 L22.4661111,24.2169118 C22.8489951,24.5997958 23.5568873,24.5997958 23.9394853,24.2169118 C24.3795016,23.7768382 24.3505637,23.138317 23.9394853,22.7243219 L18.5812255,17.3277451 Z",
  id: "Path"
}))))));

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.c9ae1547.svg";
export { ForwardRef as ReactComponent };